export default {
    ADD_LUAFILES: 'ADD_LUAFILES',
    EDIT_LUAFILES: 'EDIT_LUAFILES',
    UPDATE_FULL_HANDLERS: 'UPDATE_FULL_HANDLERS',
    RESET_HANDLERS: 'RESET_HANDLERS',
    DELETE_LUAFILES: 'DELETE_LUAFILES'
}